import { StateCreator } from 'zustand';
import { AddressForm } from '../../../global-types/addresses';
import { AddressStore } from '../address-store';
import { AddressAction, AddressSlice } from './global-address-slice.types';

const initialAddressState = {
  addressData: {
    recipient: null,
    sender: null,
    digital: null,
  },
  isRecipientAddress: false,
};

export const createAddressSlice: StateCreator<AddressStore, [['zustand/devtools', never]], [], AddressSlice> = (
  set,
) => ({
  ...initialAddressState,

  // UPDATE_ADDRESSES: merge recipient/sender via `?? existing`, always null digital
  setAddressData: ({ recipient, sender }) =>
    set(
      (state) => ({
        addressData: {
          recipient: recipient ?? state.addressData.recipient,
          sender: sender ?? state.addressData.sender,
          digital: null,
        },
      }),
      false,
      AddressAction.SetAddressData,
    ),

  setRecipientAddress: (address: AddressForm) =>
    set(
      (state) => ({
        addressData: { recipient: address, sender: state.addressData.sender, digital: null },
      }),
      false,
      AddressAction.SetRecipientAddress,
    ),

  setSenderAddress: (address: AddressForm) =>
    set(
      (state) => ({
        addressData: { recipient: state.addressData.recipient, sender: address, digital: null },
      }),
      false,
      AddressAction.SetSenderAddress,
    ),

  // resetSenderAndRecipientAddresses === updateAddresses({ recipient: undefined, sender: undefined })
  // => recipient/sender keep existing (undefined ?? existing), digital nulled
  resetSenderAndRecipientAddresses: () =>
    set(
      (state) => ({
        addressData: {
          recipient: state.addressData.recipient,
          sender: state.addressData.sender,
          digital: null,
        },
      }),
      false,
      AddressAction.ResetSenderAndRecipientAddresses,
    ),

  // UPDATE_DIGITAL_ADDRESS: set digital, always null recipient + sender
  updateDigitalAddress: (address) =>
    set(
      { addressData: { recipient: null, sender: null, digital: address } },
      false,
      AddressAction.UpdateDigitalAddress,
    ),

  setIsRecipientAddress: (isRecipientAddress) =>
    set({ isRecipientAddress }, false, AddressAction.SetIsRecipientAddress),

  // CLEAN_ADDRESSES: all three null
  cleanAddresses: () =>
    set({ addressData: { recipient: null, sender: null, digital: null } }, false, AddressAction.CleanAddresses),

  reset: () => set(initialAddressState, false, AddressAction.Reset),
});
